import { PlanLimits, FREE_LIMITS, PRO_LIMITS, SubscriptionPlan } from '../models';
import { SubscriptionRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class GetPlanLimitsUseCase {
  constructor(private subscriptionRepository: SubscriptionRepository) {}

  async execute(userId: string): Promise<PlanLimits> {
    logger.debug('GetPlanLimits', 'Getting plan limits', { userId });

    const subscription = await this.subscriptionRepository.getSubscription(userId);
    const plan: SubscriptionPlan = subscription?.plan === 'pro' ? 'pro' : 'free';

    logger.debug('GetPlanLimits', 'Resolved plan', { plan });

    return plan === 'pro' ? PRO_LIMITS : FREE_LIMITS;
  }

  static getLimitsForPlan(plan: SubscriptionPlan): PlanLimits {
    return plan === 'pro' ? PRO_LIMITS : FREE_LIMITS;
  }
}
